import React, { useState } from "react";
import Item from "./Item";
import "./FAQs.css";

const data = [
  {
    question: "Is an upfront payment required for your services?",
    answer: "The payment for our services is divided into installments. For more detailed information about the payment structure, you can contact our customer service team.",
  },
  {
    question: "What is the validity period of your services?",
    answer: "Our services are valid for up to three years from the start of the agreement.",
  },
  {
    question: "What is the process for confirming an order?",
    answer:
      "Once both the client and CDRAustraliaMigration agree to proceed with the work, an initial payment is required to confirm the order. Please note that this payment is non-refundable if the client decides to discontinue the project.",
  },
  {
    question: "Will you rewrite a CDR if it gets rejected by Engineers Australia?",
    answer:
      "Our team of professional writers strictly adheres to the MSA booklet guidelines, thoroughly analyzing the document to produce a flawless report. This minimizes the likelihood of CDR rejection.",
  },
  {
    question: "How long does it usually take to complete a project?",
    answer:
      "The project duration depends on the chosen package. For example, the Normal Track takes 20 to 25 days, while the Fast Track completes in 10 to 15 days. For urgent reports, you can discuss special arrangements with our team.",
  },
  {
    question: "What is the procedure for receiving the final report?",
    answer: "Initially, a draft version is provided for the client’s review and approval. The final report is handed over only after the client has made the full payment.",
  },
  {
    question: "What can I do if I don’t have sufficient projects for my career episodes?",
    answer:
      "You can use academic, internship, or professional projects to create career episodes. It is important to select projects that clearly highlight the skills and competencies required for the role you are applying for.",
  },
  {
    question: "How much time does it take to complete the CDR process?",
    answer: "The Competency Demonstration Report process typically takes around three weeks to finalize, depending on the specific requirements.",
  },
  {
    question: "What are the common reasons for RPL report rejection?",
    answer:
      "The usual reasons for RPL rejection include plagiarism in the report, unsuitable or fake job descriptions, irrelevant work experience, and inadequate work experience.",
  },
  {
    question: "Which English proficiency tests are accepted by Engineers Australia?",
    answer: "Engineers Australia accepts IELTS and TOEFL iBT® as valid English language proficiency tests for the Skill Assessment process.",
  },
  {
    question: "Can a recent graduate apply for a Skill Assessment without work experience?",
    answer: "Yes, as work experience is not a requirement, recent graduates can apply to have their engineering qualifications assessed by Engineers Australia.",
  },
  {
    question: "Is it possible to include academic projects in my Competency Demonstration Report (CDR)?",
    answer: "Yes, academic projects completed during your professional course can be included as Career Episodes in your CDR to demonstrate your competencies.",
  },
  {
    question: "What is the purpose of the summary statement in a Competency Demonstration Report?",
    answer:
      "The summary statement outlines the key points of the career episodes, linking competencies to specific paragraphs. This helps the EA assessor quickly locate the necessary details without reviewing the entire document.",
  },
];

const FAQs = () => {
  const [active, setActive] = useState<number>(0);
  let items: Array<JSX.Element> = [];
  for (let i = 0; i < data.length; i++) items.push(<Item id={i} active={active} setActive={setActive} answers={data[i].answer} questions={data[i].question} />);
  return (
    <div className="faqs">
      <div>
        <div className="header">Frequently Asked Questions</div>
        <div className="desc">Here is the list of frequently asked questions(FAQ) regarding CDR Report Hub.</div>
        <div className="items">{items}</div>
      </div>
    </div>
  );
};

export default FAQs;

// ▶▼
